import React from 'react'
import {Range, getTrackBackground} from 'react-range'

const InputRange = ({title, value, change = () => {}, min, max, step}) => {
    return (
        <div className="form-group form-group--range">
             <label className={'calculator__control-label'}>{title}</label>
             <div style={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                padding: '0 5px'
            }}>
             <Range 
                min={min}
                max={max}
                step={step}
                values={value}
                onChange={(values) => change(values)}
                renderMark={({props, index}) => (
                    <div 
                        {...props}
                        style={{
                            ...props.style,
                            height: '16px',
                            marginTop: '-6px',
                            marginLeft: '-4px',
                            width: '16px',
                            borderRadius: '150%',
                            border: index * step < value[0] ? '3px solid #ff5c1c' : '3px solid #dcdcdc',
                            backgroundColor: index * step < value[0] ? '#ff5c1c' : '#fff'
                        }}
                    />
                )}
                renderTrack={({props, children}) => (
                    <div 
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        style={{
                            ...props.style,
                            height: '6px',
                            display: 'flex',
                            width: '100%'
                        }}
                    >
                        <div
                            ref={props.ref}
                            style={{
                                height: '5px',
                                width: '100%',
                                position: 'relative',
                                borderRadius: '4px',
                                background: getTrackBackground({
                                values: value,
                                colors: ['#ff5c1c', '#e5e5e5'],
                                min: min,
                                max: max
                                }),
                            alignSelf: 'center'
                            }}
                            >
                            {children}
                        </div>
                    </div>
                )}
                renderThumb={({props, isDragged}) => (
                    <div 
                        {...props}
                        style={{
                            ...props.style,
                            height: '24px',
                            width: '24px',
                            border: '4px solid #fff',
                            backgroundColor: '#ff5c1c',
                            borderRadius: '150%',
                            display: 'flex',
                            marginTop: '0',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: '0px 2px 6px #ccc'
                        }}
                    />
                )}
             />
             </div>
        </div>
    )
}

export default InputRange;